import AppRouter from './router/routes';
import { ToastContainer } from 'react-toastify';
import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/base.css';
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {

     AOS.init({ duration: 1200, once: false });

}, []);



  return (
    <div>
      <ToastContainer />
      <AppRouter />
    </div>
  );
}

export default App;
